import type { OfferPart } from "@/lib/offer-parts";
import type { QuoteTextPlausibilityResult } from "@shared/quote-text-plausibility";
import type { ProjectCustomPosition } from "@/components/project/leistungsverzeichnis-kalkulator";

export interface MissingServicesImport {
  entries: QuoteTextPlausibilityResult["fehlt"];
  sectionId: string;
  teil: OfferPart;
}

export function missingServiceNameKey(name: string): string {
  return name.trim().replace(/\s+/g, " ").toLocaleLowerCase("de");
}

/** Explicitly confirmed findings become ordinary editable project LV rows.
 * No quantity or price is inferred from an unstructured AI finding. */
export function prepareMissingServicesImport(
  request: MissingServicesImport,
  existingNames: string[],
  allowedSectionIds: string[],
  createId: () => string = () => crypto.randomUUID(),
): { positions: ProjectCustomPosition[]; teile: Record<string, OfferPart> } {
  if (!allowedSectionIds.includes(request.sectionId)) {
    throw new Error("Bitte einen verfügbaren LV-Bereich auswählen.");
  }
  if (!["A", "B", "C"].includes(request.teil)) {
    throw new Error("Bitte einen gültigen Angebotsteil auswählen.");
  }
  const names = new Set(existingNames.map(missingServiceNameKey));
  const positions: ProjectCustomPosition[] = [];
  const teile: Record<string, OfferPart> = {};
  for (const entry of request.entries) {
    const key = missingServiceNameKey(entry.leistung);
    if (!key || names.has(key)) continue;
    names.add(key);
    const id = `custom-${createId()}`;
    positions.push({
      id,
      sektionId: request.sectionId,
      name: entry.leistung,
      beschreibung: entry.zitat,
      unit: "psch",
      qty: 1,
      ep: 0,
      aktiv: true,
    });
    teile[id] = request.teil;
  }
  return { positions, teile };
}
